var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaleasBw3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_34_339)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#CCCCCC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.19048,
    y: 0.190476,
    width: 35.619,
    height: 35.619,
    rx: 17.8095,
    stroke: "black",
    strokeWidth: 0.380952,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_34_339",
    maskUnits: "userSpaceOnUse",
    x: 10.4287,
    y: 8.28564,
    width: 19,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 10.4287,
    y: 8.28564,
    width: 19,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4564 26.2856L23.1866 22.1169H16.8017L15.5319 26.2856H11.5309L17.7121 8.70023H22.2522L28.4574 26.2856H24.4564ZM22.3001 19.0023C21.1262 15.2249 20.4633 13.0886 20.3116 12.5935C20.1678 12.0983 20.064 11.707 20.0001 11.4195C19.7366 12.4417 18.9819 14.9693 17.7361 19.0023H22.3001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.4564 26.2856L23.1866 22.1169H16.8017L15.5319 26.2856H11.5309L17.7121 8.70023H22.2522L28.4574 26.2856H24.4564ZM22.3001 19.0023C21.1262 15.2249 20.4633 13.0886 20.3116 12.5935C20.1678 12.0983 20.064 11.707 20.0001 11.4195C19.7366 12.4417 18.9819 14.9693 17.7361 19.0023H22.3001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4564 26.2856L24.092 26.3966L24.1742 26.6666H24.4564V26.2856ZM23.1866 22.1169L23.551 22.0059L23.4688 21.7359H23.1866V22.1169ZM16.8017 22.1169V21.7359H16.5195L16.4373 22.0059L16.8017 22.1169ZM15.5319 26.2856V26.6666H15.8141L15.8963 26.3966L15.5319 26.2856ZM11.5309 26.2856L11.1715 26.1593L10.9932 26.6666H11.5309V26.2856ZM17.7121 8.70023V8.31927H17.4422L17.3527 8.5739L17.7121 8.70023ZM22.2522 8.70023L22.6115 8.57346L22.5218 8.31927H22.2522V8.70023ZM28.4574 26.2856V26.6666H28.9958L28.8167 26.1589L28.4574 26.2856ZM22.3001 19.0023V19.3833H22.8175L22.6639 18.8893L22.3001 19.0023ZM20.3116 12.5935L19.9457 12.6997L19.9474 12.7051L20.3116 12.5935ZM20.0001 11.4195L20.372 11.3369L19.6312 11.3244L20.0001 11.4195ZM17.7361 19.0023L17.3721 18.8899L17.2197 19.3833H17.7361V19.0023ZM24.8208 26.1746L23.551 22.0059L22.8222 22.2279L24.092 26.3966L24.8208 26.1746ZM23.1866 21.7359H16.8017V22.4978H23.1866V21.7359ZM16.4373 22.0059L15.1675 26.1746L15.8963 26.3966L17.1661 22.2279L16.4373 22.0059ZM15.5319 25.9047H11.5309V26.6666H15.5319V25.9047ZM11.8903 26.412L18.0715 8.82655L17.3527 8.5739L11.1715 26.1593L11.8903 26.412ZM17.7121 9.08118H22.2522V8.31927H17.7121V9.08118ZM21.893 8.82699L28.0982 26.4124L28.8167 26.1589L22.6115 8.57346L21.893 8.82699ZM28.4574 25.9047H24.4564V26.6666H28.4574V25.9047ZM22.6639 18.8893C21.4898 15.1113 20.8273 12.976 20.6758 12.4818L19.9474 12.7051C20.0994 13.2011 20.7626 15.3385 21.9364 19.1154L22.6639 18.8893ZM20.6774 12.4872C20.5346 11.9951 20.4333 11.6127 20.372 11.3369L19.6283 11.5021C19.6947 11.8013 19.8011 12.2016 19.9458 12.6997L20.6774 12.4872ZM19.6312 11.3244C19.3705 12.3359 18.6189 14.8537 17.3721 18.8899L18.1001 19.1147C19.3449 15.085 20.1027 12.5475 20.369 11.5146L19.6312 11.3244ZM17.7361 19.3833H22.3001V18.6214H17.7361V19.3833Z",
    fill: "black",
    mask: "url(#path-3-outside-1_34_339)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_34_339",
    x: 0.47619,
    y: 0,
    width: 39.0476,
    height: 39.0476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.52381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.761905
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34_339"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34_339",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaleasBw3);
export default __webpack_public_path__ + "static/media/TaleasBW3.97a5550146e78c62b67e700b11fd8264.svg";
export { ForwardRef as ReactComponent };